import { SingularNoun } from '../../types'

const хуйня: SingularNoun = {
  type: 'singular noun',
  nominativeSingular: 'хуйня',
  genitiveSingular: 'хуйни',
  dativeSingular: 'хуйне',
  accusativeSingular: 'хуйню',
  instrumentalSingular: 'хуйнёй',
  prepositionalSingular: 'хуйне',
}

export default хуйня
